import { createFileRoute } from '@tanstack/react-router';
import { IntakeClient } from '@/features/intake/IntakeClient';

export const Route = createFileRoute('/_shell/intake')({
  component: IntakeClient,
});
